export default __webpack_public_path__ + "static/media/WBGlogo.dcb360af.png";